<template>
  <div class="intro">
    <img src="./socialmedia1.jpg" alt="">
    <div class="title">現在的你，為什麼在交友軟體上認識人很難？</div>
    <div class="pre">
      嗨，你好我們是 Let’s Movie 的創辦團隊<br />
      很高興你點開來看了
    </div>
    <div class="pre">
      我們希望能有個東西<br />
      能極大的降低你認識新朋友所花的成本<br />
      目的是希望有更多的時間把自己過得更好<br />
      過的更平衡
    </div>
    <p>
      我常常在想，交朋友認識人，他的本質是什麼<br />
      在這尋找與被尋找的過程<br />
      我們花了許多的時間心力以及金錢<br />
      尋找一個契合的，有趣的靈魂<br />
      這過程中有挺多的困難<br />
      但我想其中最難的<br />
      其實是因為外在環境的不允許<br />
      比如工作讓我們心力交瘁<br />
      沒辦法分神花心思去認識異性<br />
    </p>
    <p>
      說到這<br />
      我想到有個故事可以跟你分享<br />
      我有個朋友，姑且叫他小張<br />
      他以前是一個重度交友軟體的使用者<br />
      手機裡至少裝了不下五款交友軟體<br />
      坊間的兩性書籍，教說話，教把妹的<br />
      他都有涉獵<br />
      跟他約出來吃飯<br />
      常常有一個情況是<br />
      聊到一半，他亮出他的手機說<br />
    </p>
    <p class="talk">
      “欸我剛約到一個女生出來吃飯了”
    </p>
    <p>
      當下我們所有人都會對他投射熾熱的眼光<br />
      熾熱地想要殺死他的眼光<br />
      可以說，當時的他，情場得意，意氣風發<br />
      我們也一直以為這樣的情境<br />
      就是我們朋友之間互發牢騷的有趣日常<br />
      但這段美好時光在他正式出了社會之後<br />
      發生了變化<br />
      小張，因為過去有點荒唐的歲月<br />
      導致他時常覺得自己的成就矮同儕一截<br />
      於是他埋首在工作中，成為了一個工作狂<br />
      我們之間聊天的話題<br />
      從聊娛樂跟異性<br />
      變成了工作跟感嘆<br />
      他感嘆他的過往黃金年代桃花朵朵開<br />
      我們則感嘆著以前不好好把握<br />
      出社會之後想認識人更難了<br />
      他有一段感嘆時常掛在嘴邊<br />
    </p>
    <p class="talk">
      “以前打開交友軟體“<br />
      “都可以信手拈來的講開場白“<br />
      “很自然地逗笑女生“<br />
      “現在腦袋都裝工作“<br />
      “打開軟體左滑右滑“<br />
      “好不容易配對到了卻不知道要怎麼起頭了“<br />
      “總不可能跟他聊今天開會的內容吧”<br />
    </p>
    <p>
      這是他感嘆情節的倒數第二句
    </p>
    <p class="talk">
      “我現在只是個只懂工作的死肥宅”
    </p>
    <p>
      這是最後一句<br />
      然後非常有默契的<br />
      我們一起講出<br />
    </p>
    <p class="talk">
      “人生啊，唉“
    </p>
    <p>
      所以，認識異性真的變的那麼難嗎？
    </p>
    <p>
      其實不是變難了<br />
      而是我們的人生階段不允許<br />
      一次投注這麼多的心思在認識異性上面了<br />
      因為其他的人生目標開始大量佔據我們的時間跟心力<br />
    </p>
    <p>
      我們希望能有個東西<br />
      能極大的降低你認識新朋友所花的成本<br />
      目的是希望有更多的時間把自己過得更好<br />
      過的更平衡<br />
      所以我們開發了 <span>Let’s Movie電影約會 Bot</span><br />
    </p>
    <p>是說後來小張也來用我們的服務了</p>
    <p class="talk">
      “以前要想開場白”<br />
      “現在只要問對方，要約什麼時候跟約哪就好”<br />
      “直接就是約會“<br />
      “我最近把有在付費的那些交友軟體都停掉了”<br />
    </p>
    <p class="talk">
      “喔？你之前一個月付多少在交友軟體上”<br />
      “嗯嗯我想一下，大概少的話一兩千，曾經最多也有四五千吧”<br />
      “而且以前付了錢，還要花很多時間去聊天”<br />
      “那背後的隱形成本不知道多花多少去了”<br />
      “現在大概就是偶爾刷一下想約會”<br />
      “發邀請，配對，喬時間，結束”<br />
      “一個禮拜不用到兩小時吧”<br />
      “重返黃金年代！”<br />
    </p>
    <p>
      你是一個重視自己時間的人嗎？<br />
      你是一個工作忙碌的人嗎？<br />
      一個月一場電影約會<br />
      面對面認識一個異性<br />
      需要的是120 - 500元的媒合費<br />
      比加起來動輒幾千元的交友軟體會員費要少得多<br />
      當然我們更想要的是幫你把時間節省下來<br />
      讓你留更多的時間給自己<br />
      直接見面是最有效率認識女生的方式<br />
      如果不喜歡，也能做一般朋友<br />
      而不會花大部分時間在網路上<br />
      最後只成為網友<br />
    </p>
    <p>
      我們歡迎更多像小張一樣的男孩<br />
      來使用我們的服務<br />
      讓我們協助你節省你的時間<br />
      讓你有更多的心力，為自己的人生加點色彩<br />
    </p>
    <div class="end">
      Let’s Movie 電影約會團隊 祝你約會順利
    </div>
  </div>
</template>
<style lang="scss" scoped>
.intro {
  width: 1280px;
  margin: 0px auto;
  text-align: justify;

  img  {
    width: 100%;
  }
  
  .title {
    font-size: 36px;
    color: #333;
    margin-bottom: 30px;
  }

  .pre {
    margin-bottom: 30px;
  }

  p {
    line-height: 2.5;
    margin-bottom: 15px;
  }

  .talk {
    color: #000;
    font-weight: bold;
    font-size: 17px;
    margin-left: -0.5rem;
  }

  .end {
    font-size: 20px;
    color: #990000;
    margin-top: 30px;
  }

}

/* 螢幕尺寸標準 */
/* 平板尺寸 */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
}

/* 手機尺寸 */
@media only screen and (max-width: 767px) {
  .intro {
    width: 100vw;
    padding: 0 5vw;
    margin-top: 0px;

    img {
      width: 100vw;
      margin-left: -5vw;
    }

    .title {
      font-size: 24px;
      font-weight: bold;
    }

    .pre {

    }

    p {
      font-size: 14px;
      line-height: 30px;
    }

    .talk {
      font-size: 15px;
    }

    .end {
      font-size: 16px;
      margin-bottom: 30px;
    }
  }
}

// 避免內容電腦過渡平板時，設計未考量的調整
@media only screen and (min-width: 1025px) and (max-width: 1199.98px) {
}

// 避免過度到 1280 x 720 時，設計未考量的調整
@media only screen and (min-width: 1025px) and (max-width: 1280px) {
}
</style>

<script>
// @ is an alias to /src
// import Loading from '@/components/Loading.vue'
// import { setTimeout } from 'timers'

export default {
  name: 'intro',
  components: {
    // Loading,
  },

  data() {
    return {
    }
  },

  methods: {},

  created() {
  },
}
</script>
